import { Component } from '@angular/core';
import { UserService } from '../../user.service';
import { Router } from '@angular/router';
import { UniversalStorageService } from '../../../services/universal-storage.service';

@Component({
    selector: 'app-close-account',
    templateUrl: './close-account.component.html',
    styleUrls: ['./close-account.component.scss'],
})
export class CloseAccountComponent {
    user_name: string | null;
    user_email: string | null;
    loginSuccess = false;
    message: string;
    message_error: string;
    first_name: string;
    imis_id: string;
    constructor(
        private userservice: UserService,
        private router: Router,
        private storageService: UniversalStorageService
    ) {
        this.user_name = this.storageService.getItem('loggedInUsername');
        const token = this.storageService.getItem('BEARER_TOKEN'); // Replace with your token storage mechanism
        if (token) {
            const tokenPayload = this.decodeToken(token);
            this.user_email = tokenPayload.data.email;
            this.first_name = tokenPayload.data.firstname;
            this.imis_id = tokenPayload.data.imis_id;
        }
    }
    private decodeToken(token: string) {
        const tokenParts = token.split('.');
        if (tokenParts.length !== 3) {
            throw new Error('Invalid token format');
        }

        const tokenPayload = JSON.parse(atob(tokenParts[1]));
        return tokenPayload;
    }
    closeAccount() {
        const data = { email: this.user_email, imisid: this.imis_id }; // Create an object with the email

        this.userservice.closeUserAccount(data).subscribe(
            (response) => {
                if (response['status'] == 200) {
                    this.loginSuccess = true;
                    this.message = response['message'];

                    setTimeout(() => {
                        this.router.navigate(['/home']);
                    }, 1000);
                    // home
                } else {
                    this.loginSuccess = false;
                    this.message_error = response['message'];
                }
            },
            (error) => {
                console.error('An error occurred:', error);
            }
        );
    }
}
